import {ApiRes} from '@type/api'
import {apiPost} from '@api/api'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiSendEmailConfirmCode = async (email: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost(`signin/code`, {email: email})
}
